<svg width="60" height="60" version="1.1" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
 <path id="burger_icon" d="m8 9.2h8v0.8h-8zm0 4.8h6v0.8h-6zm0-2.4h8v0.8h-8z" stroke-width=".4"/>
</svg>
